import styled from "react-emotion";

const HeroBox = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
`;

export default HeroBox;
